export const hasTaskPermission = (task, loginUserId, loginUserRole) => {
  return (
    task?.added_by === loginUserId ||
    task?.owners?.some((owner) => owner.user_id === loginUserId) ||
    ["ADMIN", "MANAGER"].includes(loginUserRole)
  );
};
